// The demos show a translation next to each word. Show it in the visitor's own
// language instead of always Japanese, so the page doesn't read as Japan-only.
// English (or any language we have no entry for) falls back to Spanish.
const FALLBACK = 'es';

export const pickTranslation = (translations) => {
  const langs = typeof navigator === 'undefined' ? [] : navigator.languages || [navigator.language];
  for (const tag of langs) {
    const base = (tag || '').toLowerCase().split('-')[0];
    if (translations[base]) return translations[base];
  }
  return translations[FALLBACK];
};
